// extracted by mini-css-extract-plugin
export default {"root":"WatchListForm-module_root__T62FT","title":"WatchListForm-module_title__uzne8","lead":"WatchListForm-module_lead__rZBpy"};